import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CustomerPaymentsList from '../components/content/customers/CustomerPaymentsList';
import PaymentPlanDetails from '../components/content/customers/PaymentPlanDetails';

const UserPaymentsView = () => (
  <Routes>
    <Route element={<CustomerPaymentsList />} path="/" />
    <Route
      element={<PaymentPlanDetails />}
      path="/plans/:pkRegCart/:pkRegCartPayment"
    />
    <Route element={<Navigate replace to="/payments" />} path="*" />
  </Routes>
);

export default UserPaymentsView;
